import { spring as spring$1 } from '@motionone/generators';
import { createGeneratorEasing } from '../create-generator-easing.es.js';

const spring = createGeneratorEasing(spring$1);

export { spring };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/easing/spring/index.es.js
// module id = Ig0O
// module chunks = 0